import { createSlice } from "@reduxjs/toolkit";
import {IstudentFinanceAccountDetailslice } from "../../../models/student/studentAccountsDetails";

const InitialStudentFinancialAccountDetails : IstudentFinanceAccountDetailslice = {
    financeAccountDetail : undefined
}

const studentFinancialAccountDetails = createSlice({
    name: 'financeAccountDetail',
    initialState:InitialStudentFinancialAccountDetails,
    reducers: {
        setStudentFinancialAccountDetail: (state, action: { payload: any }) => {
          state.financeAccountDetail = action.payload;
        },
    },
})

export const { setStudentFinancialAccountDetail } = studentFinancialAccountDetails.actions;

const StudentFinancialAccountDetailReducer = studentFinancialAccountDetails.reducer;

export type studentFinancialAccountState = ReturnType<typeof StudentFinancialAccountDetailReducer>;

export default StudentFinancialAccountDetailReducer;